/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../Tema";
import anato from '../Recursos/logo_ananto.png'
import precios from '../Recursos/logo_plazos_juztos.svg'
import rnt from '../Recursos/logo_rnt.png'
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../Servicios/BD/obtenerColWheres";
import {useNavigate} from "react-router-dom";


const Footer = () => {
    const {sCell, masSM} = useResponsive()
    const navigate = useNavigate()
    const [adicionales, setAdicionales] = useState([])

    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'adicionales', wheres: w}).then((dox) => {
            setAdicionales(dox.data)
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: theme.palette.primary.main}}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 6}}
            >

                <Grid container size={{xs: 12, sm: 6, md: 3}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{color: '#fff', fontWeight: 800, fontSize: 14}}>
                                RECEPTOUR DEL CARIBE S.A.S
                                <br/>
                                Nit: 892.400.201-7
                                <br/>
                                RNT # 3333
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <img src={anato} width={200} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                                <Grid container size={{xs: 4, sm: 4, md: 5}} sx={{justifyContent: 'flex-start'}}>
                                    <img src={rnt} width={110} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <img src={precios} width={60} height={'auto'}/>
                                </Grid>

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{color: '#fff'}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontWeight: 600}}>Paginas Adicionales</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{color: '#fff', mt: 1}}
                        >

                            {adicionales.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography
                                            onClick={() => navigate('/Adicionales/' + it.id)}
                                            sx={{
                                                transition: 'all .1s ease-in-out',
                                                fontSize: 14,
                                                borderBottom: 1,
                                                borderColor: '#ffffff00',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    borderColor: '#ffffff',
                                                },
                                                lineHeight: 1.2

                                            }}
                                        >{it.nombre}</Typography>
                                    </Grid>
                                )
                            })}

                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start', mt: !masSM ? 4 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{color: '#fff'}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontWeight: 600}}>Horarios</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Typography sx={{fontWeight: 400, fontSize: 14}}>
                                Lunes a Viernes:
                                8:00 am – 12:00 pm y 2:00 pm – 5:30 pm.
                                <br/>
                                <br/>
                                Sábado: 9:00 am a 12:30 pm
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', p: 2}}>
                <Typography sx={{color: '#fff', textAlign: 'center', fontWeight: 300}}>
                    © Copyright 2025 - 2026 | Receptour del Caribe S.A.S
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Footer